import 'bootstrap';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js